import { AxiosError } from "axios";
import AjexPortalService from "./api";
import config from "./config";
import { getNotificationStyle } from "../common/notification";
import { IManualWaybill, IManualWaybillPrintInfo, IManualWaybillApproveRejectRequest, IManualWaybillApprovalFilter, PrintVersion } from "../model/ManualWaybillModel";

const manualWaybillUrl = process.env.REACT_APP_TMS_MANUAL_WAYBILL_SERVICE;

const manualWaybill = config.get('manualWaybill');
const create = config.get("create");
const ref_req = config.get("ref_req");
const printDetails = config.get("printDetails");
const approvedRejected = config.get("manualWaybillApprovedRejected");
const approvedRejectedPaginated = config.get("manualWaybillApprovedRejectedPaginated");
const getActiveProducts = config.get("getActiveProducts");

export const GetManualWaybillListService = async () => {
    try {
        return await AjexPortalService.get(`${manualWaybillUrl}${manualWaybill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetActiveProductsService = async () => {
    try {
        return await AjexPortalService.get(`${manualWaybillUrl}${manualWaybill}/${getActiveProducts}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetManualWaybillService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${manualWaybillUrl}${manualWaybill}/${id}?${ref_req}=true`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveManualWaybillService = async (data: IManualWaybill) => {
    try {
        return await AjexPortalService.post(`${manualWaybillUrl}${manualWaybill}/${create}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const PrintManualWaybillService = async (id: number, version: PrintVersion) => {
    try {
        return await AjexPortalService.post(`${manualWaybillUrl}${manualWaybill}/data/${id}?${ref_req}=true`, {
            pageFormat: "A5",
            dataWithTemplate: false,
            version,
        });
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveManualWaybillPrintInfoService = async (data: IManualWaybillPrintInfo) => {
    try {
        return await AjexPortalService.post(`${manualWaybillUrl}${manualWaybill}/${printDetails}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const GetManualWaybillPrintInfoService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${manualWaybillUrl}${manualWaybill}/${printDetails}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DeleteManualWaybillService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${manualWaybillUrl}${manualWaybill}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetManualWaybillApprovalListService = async (
    page: number,
    size: number,
    statusId: number,
    filter?: IManualWaybillApprovalFilter,
) => {
    try {
        const params = new URLSearchParams({
            page: String(page),
            size: String(size),
            statusId: String(statusId),
        });
        if (filter?.originCityId) params.append('originCityId', String(filter.originCityId));
        if (filter?.destCityId) params.append('destCityId', String(filter.destCityId));
        if (filter?.salesPersonId) params.append('salesPersonId', String(filter.salesPersonId));
        if (filter?.fromDate) params.append('fromDate', filter.fromDate);
        if (filter?.toDate) params.append('toDate', filter.toDate);
        return await AjexPortalService.get(
            `${manualWaybillUrl}${manualWaybill}/${approvedRejectedPaginated}?${params.toString()}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const ApproveRejectManualWaybillService = async (id: number, data: IManualWaybillApproveRejectRequest) => {
    try {
        return await AjexPortalService.put(`${manualWaybillUrl}${manualWaybill}/${approvedRejected}/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};